import { defaultTransition } from './transitions';

export const fadeInOut = {
    exit: {
        opacity: 0,
        transition: defaultTransition,
    },
    initial: {
        opacity: 0,
        transition: defaultTransition,
    },
    animate: {
        opacity: 1,
        transition: defaultTransition,
    },
};
